<template>
  <div class="container">
    <div class="row">
      <div class="col-sm-9 col-md-7 col-lg-5 mx-auto">
        <div class="card card-signin my-5">
          <div class="card-body p-5">
            <img class="pb-5" src="/img/mquest_logo.png" width="100%" />
            <form
              class="form-signin"
              v-promise-btn="{ action: 'submit' }"
              @submit.prevent="login"
            >
              <div class="form-label-group">
                <input
                  type="text"
                  v-model="email"
                  id="inputEmail"
                  :class="`form-control ${errors.length ? 'is-invalid' : ''}`"
                  placeholder="Email"
                  required
                  autofocus
                />
              </div>

              <div class="form-label-group">
                <input
                  type="password"
                  v-model="password"
                  id="inputPassword"
                  :class="`form-control ${errors.length ? 'is-invalid' : ''}`"
                  placeholder="Contraseña"
                  required
                />
              </div>

              <div
                v-for="error in errors"
                :key="error"
                class="alert alert-danger"
                role="alert"
              >
                {{ error }}
              </div>

              <div class="custom-control custom-checkbox mb-3">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="customCheck1"
                />
                <label class="custom-control-label" for="customCheck1"
                  >Recordar contraseña</label
                >
              </div>
              <button
                class="btn bg-primary text-white btn-lg btn-primary btn-block text-uppercase"
                type="submit"
              >
                Iniciar sesión
              </button>
              <hr class="my-4" />
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "LoginSection",
  data: function () {
    return {
      email: "",
      password: "",
      errors: [],
    };
  },
  methods: {
    async login() {
      this.errors = [];

      await axios.get("/csrf-cookie");
      const fd = new FormData();
      fd.append("nom_usuario", this.email);
      fd.append("contrasena", this.password);
      const response = await axios.post("/login", fd);
      if (response.data.ok) {
        const usuario = response.data.user;
        const permisos = response.data.permissions;

        localStorage.setItem("usuario", JSON.stringify(usuario));
        localStorage.setItem("permisos", JSON.stringify(permisos));

        localStorage.setItem("loggedIn", true);

        this.$router.push({ path: "/admin/overview" });
      } else {
        this.errors.push("El usuario o contraseña no son válidos");
      }
      return 1;
    },
  },
};
</script>

<style scoped>
.form-label-group {
  padding: 10px;
}

.custom-checkbox {
  padding-left: 2rem !important;
}
</style>
